import CalculStatistiqueFormController from './calcul.statistique.form.controller';

export default {
    template: require('./calcul.statistique.form.html'),
    controller: CalculStatistiqueFormController
};
